import React from "react";
import DashboardShape1 from "./components/DashboardShape1";
import DashboardShape2 from "./components/DashboardShape2";
import PaymentSchedule from "./components/PaymentSchedule";

const Dashboard = () => {
	return (
		<section className="dashboard-section">
			<div className="dashboard-shape">
				<DashboardShape1 />
			</div>
			<div className="dashboard-shape-2">
				<DashboardShape2 />
			</div>
			<div className="container">
				<div className="section-title">
					<h2 className="title">Dashboard</h2>
				</div>
				<div className="dashboard-info">
					<h5 className="subtitle">Overview</h5>
					<ul className="info">
						<li>
							<span>Projects Available:</span>
							<span className="text-base">4</span>
						</li>
						<li>
							<span>My Projects:</span>
							<span className="text-base">1</span>
						</li>
						<li>
							<span>My Staking Tier:</span>
							<span className="text-base">2</span>
						</li>
						<li>
							<span>Entitlement used:</span>
							<span className="text-base">0/1000 ALGO</span>
						</li>
						<li>
							<span>Entitlement Remaining:</span>
							<span className="text-base">0/1000 ALGO</span>
						</li>
					</ul>
				</div>
				<PaymentSchedule />
			</div>
		</section>
	);
};

export default Dashboard;
